import { render, staticRenderFns } from "./CreateInvoice.yaml?vue&type=template&id=8be9d6a0&component"
import script from "./CreateInvoice.yaml?vue&type=script&lang=ts&component"
export * from "./CreateInvoice.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports